import type { TSEOComponentData } from "../cms/types";

export type MapSEOTagsReturnType = Pick<
  TSEOComponentData,
  | "metaTitle"
  | "keywords"
  | "metaViewport"
  | "canonicalURL"
  | "metaDescription"
  | "metaRobots"
> & {
  metaImage?: string;
};

export const populateSEO = {
  seo: {
    populate: ["metaSocial", "metaSocial.image", "metaImage"],
  },
};

export const mapSEOTags = (
  data: TSEOComponentData | undefined,
): MapSEOTagsReturnType => ({
  metaTitle: data?.metaTitle,
  keywords: data?.keywords,
  metaImage: data?.metaImage?.url,
  metaViewport: data?.metaViewport || "width=device-width, initial-scale=1.0",
  canonicalURL: data?.canonicalURL,
  metaDescription: data?.metaDescription,
  metaRobots: data?.metaRobots,
});
